import { CHART_X_PADDING, CHART_X_PADDING_MOBILE } from "../../../components/chart/hooks"
import { styled, theme } from "../../../styles/stitches.config"

export const ChartLegendContainer = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "flex-start",

  gap: theme.space.s6,

  paddingInline: CHART_X_PADDING_MOBILE,

  "@sm": {
    justifyContent: "center",
  },

  "@md": {
    paddingInline: CHART_X_PADDING,
  },

  "@lg": {
    justifyContent: "flex-end",
    gap: theme.space.s12,
  },
})
